import { MsUserApi } from "@microtica/ms-usermanagement-sdk";
import { MsProjectApi } from "@microtica/ms-project-sdk";
import { MsKubeApi } from "@microtica/ms-kube-sdk";
import { MsElasticsearchApi } from "@microtica/ms-elasticsearch-sdk";
import { MsEngineApi } from "@microtica/ms-engine-sdk";
import { MsAwsApi } from "@microtica/ms-aws-sdk";
import { MsApApi } from '@microtica/ms-ap-sdk';
import { MsNotificationApi } from "@microtica/ms-notification-sdk";
import { env } from "../env";
import { io } from "socket.io-client";

export function getBaseUrl(): string {
    return env.REACT_APP_BACKEND_ENDPOINT;
};

export function getIdToken(): string | undefined {
    if (process.env.NODE_ENV === "test") {
        return "testing_access_token";
    }
    return localStorage.getItem("idToken") || undefined;
}

export function getUserManagementService() {
    return new MsUserApi({
        basePath: `${getBaseUrl()}/ms-usermanagement`,
        accessToken: getIdToken()
    });
}

export function getProjectService() {
    return new MsProjectApi({
        basePath: `${getBaseUrl()}/ms-project`,
        accessToken: getIdToken()
    });
}

export function getKubeService() {
    return new MsKubeApi({
        basePath: `${getBaseUrl()}/ms-kube`,
        accessToken: getIdToken()
    });
}

export function getElasticSearchService() {
    return new MsElasticsearchApi({
        basePath: `${getBaseUrl()}/ms-elasticsearch`,
        accessToken: getIdToken()
    });
}

export function getEnvironmentService() {
    return new MsEngineApi({
        basePath: `${getBaseUrl()}/ms-engine`,
        accessToken: getIdToken()
    });
}

export function getCloudService() {
    return new MsAwsApi({
        basePath: `${getBaseUrl()}/ms-aws`,
        accessToken: getIdToken()
    });
}

export function getPipelinesService() {
    return new MsApApi({
        basePath: `${getBaseUrl()}/ms-ap`,
        accessToken: getIdToken()
    });
}

export function getNotificationService() {
    return new MsNotificationApi({
        basePath: `${getBaseUrl()}/ms-notification`,
        accessToken: getIdToken()
    });
}

export function getRealtimeService(queryParams: any) {
    return io(
        getBaseUrl(), {
        path: "/ms-realtime/websockets/",
        withCredentials: true,
        reconnection: false,
        transports: ['websocket'],
        query: {
            ...queryParams,
            Authorization: `Bearer ${getIdToken()}`
        }
    });
}

export function disconnectRealtimeService() {
    return io().disconnect();
}